module.exports = __webpack_public_path__ + "static/Pressure_panel-49f73a4aa2b149753c456cf48f2e1301.png";